export default "__VITE_ASSET__SzdrM_FR__"